var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3333C0 24.2538 0.746192 25 1.66667 25H20C20.9205 25 21.6667 24.2538 21.6667 23.3333C21.6667 22.4129 20.9205 21.6667 20 21.6667H1.66667C0.746191 21.6667 0 22.4129 0 23.3333ZM0 15C0 15.9205 0.746192 16.6667 1.66667 16.6667H15C15.9205 16.6667 16.6667 15.9205 16.6667 15C16.6667 14.0795 15.9205 13.3333 15 13.3333H1.66667C0.746191 13.3333 0 14.0795 0 15ZM1.66666 5C0.746189 5 0 5.74619 0 6.66667C0 7.58714 0.746192 8.33333 1.66667 8.33333H20C20.9205 8.33333 21.6667 7.58714 21.6667 6.66667C21.6667 5.74619 20.9205 5 20 5H1.66666ZM28.8258 22.1575C29.4746 21.5088 29.4753 20.4572 28.8275 19.8075L24.0333 15L28.8275 10.1925C29.4753 9.54283 29.4746 8.49123 28.8258 7.84249C28.1764 7.1931 27.1236 7.1931 26.4742 7.84249L20.7309 13.5858C19.9498 14.3668 19.9498 15.6332 20.7309 16.4142L26.4742 22.1575C27.1236 22.8069 28.1764 22.8069 28.8258 22.1575Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpen);
export default __webpack_public_path__ + "static/media/menu_open.9f5d35b71e1f8160cc5a3b6597b4b3cb.svg";
export { ForwardRef as ReactComponent };